// Mock data for arts4all clone. Text fields are bilingual { it, en }.
// This data will later be served / persisted from the backend where relevant.

export const heroSlides = [
  {
    image:
      "https://images.unsplash.com/photo-1511715282680-fbf93a50e721?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjb250ZW1wb3JhcnklMjBkYW5jZXxlbnwwfHx8fDE3ODM2NzIyNzd8MA&ixlib=rb-4.1.0&q=85",
    caption: { it: "Danza", en: "Dance" },
  },
  {
    image:
      "https://images.unsplash.com/photo-1465847899084-d164df4dedc6",
    caption: { it: "Musica", en: "Music" },
  },
  {
    image:
      "https://images.unsplash.com/photo-1615414015111-8d98cb65677e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHx0aGVhdHJlJTIwc3RhZ2V8ZW58MHx8fHwxNzgzNjcyMjc3fDA&ixlib=rb-4.1.0&q=85",
    caption: { it: "Teatro", en: "Theatre" },
  },
  {
    image:
      "https://images.unsplash.com/photo-1501084817091-a4f3d1d19e07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxhcnQlMjBzdHVkaW98ZW58MHx8fHwxNzgzNjcyMjgzfDA&ixlib=rb-4.1.0&q=85",
    caption: { it: "Arti Visive", en: "Visual Arts" },
  },
];

export const stats = [
  { value: "50+", key: "statsEvents" },
  { value: "17", key: "statsYears" },
  { value: "200+", key: "statsArtists" },
  { value: "14", key: "statsEditions" },
];

export const projects = [
  {
    id: "interdanza",
    slug: "/interdanza",
    name: "Interdanza",
    image:
      "https://images.unsplash.com/photo-1529229504105-4ea795dcbf59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjb250ZW1wb3JhcnklMjBkYW5jZXxlbnwwfHx8fDE3ODM2NzIyNzd8MA&ixlib=rb-4.1.0&q=85",
    tag: { it: "Danza · dal 2013", en: "Dance · since 2013" },
    excerpt: {
      it: "Workshop, stages internazionali e il grande Gala \"Sulle ali della danza\" al Teatro Goldoni.",
      en: "Workshops, international stages and the great Gala \"Sulle ali della danza\" at the Teatro Goldoni.",
    },
  },
  {
    id: "arte-natura",
    slug: "/arte-e-natura",
    name: "Arte & Natura",
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/35pl6f16_484982536_680468811313463_499751557762737408_n.jpg",
    tag: { it: "Arte & Natura · 2023", en: "Art & Nature · 2023" },
    excerpt: {
      it: "Quattro appuntamenti tra arte, danza e musica dedicati alla natura e all'ambiente.",
      en: "Four events across art, dance and music dedicated to nature and the environment.",
    },
  },
];

export const founders = [
  {
    name: "Eva Kosa",
    role: { it: "Presidente", en: "President" },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/1iv6yh87_1740781636076.jpeg",
    bio: {
      it: "Docente di danza classica e contemporanea, attualmente insegna danza classica presso la scuola Officina delle Arti (Pieve a Nievole, PT). Direttrice artistica e organizzativa del progetto Interdanza (Livorno) e artistic agent del M° Luca D'Annunzio. Diplomata al Liceo di Coreografia e Arte Drammatica \"O. Stroia\" e laureata in Pedagogia Coreografica all'Accademia di Musica \"Gh. Dima\" di Cluj-Napoca (Romania); Master in Arts and Culture Management alla Rome Business School. Già ballerina del Teatro dell'Opera di Brasov, si è perfezionata nella danza contemporanea (metodo Cunningham) con Dino Verga presso Aterballetto. Come coreografa ha firmato \"Aggiungi un posto a tavola\" e, per la Fondazione Goldoni di Livorno, \"Orfeo ed Euridice\", \"Traviata\" e \"Sì\".",
      en: "Teacher of classical and contemporary dance, currently teaching classical dance at the Officina delle Arti school (Pieve a Nievole, PT). Artistic and organisational director of the Interdanza project (Livorno) and artistic agent of Maestro Luca D'Annunzio. She graduated from the \"O. Stroia\" Choreography and Drama Lyceum and holds a degree in Choreographic Pedagogy from the \"Gh. Dima\" Music Academy in Cluj-Napoca (Romania), plus a Master in Arts and Culture Management from Rome Business School. A former dancer at the Brasov Opera Theatre, she specialised in contemporary dance (Cunningham method) with Dino Verga at Aterballetto. As a choreographer she staged \"Aggiungi un posto a tavola\" and, for the Goldoni Foundation in Livorno, \"Orfeo ed Euridice\", \"Traviata\" and \"Sì\".",
    },
  },
  {
    name: "Marco Maltinti",
    role: { it: "Vicepresidente", en: "Vice President" },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/5xuvdykj_1680279805574.jpeg",
    bio: {
      it: "Web Marketing Manager e Digital Strategist, fondatore di Civico8ADV, agenzia di comunicazione e marketing digitale con sede a Livorno. Si occupa di brand strategy, social media management, campagne META ADS, posizionamento e storytelling per aziende, professionisti e destinazioni. Collabora stabilmente con PR Comunicare il Vino, curando la strategia digitale di alcune tra le più riconosciute cantine italiane. Ha studiato pianoforte all'Istituto Musicale Pietro Mascagni di Livorno.",
      en: "Web Marketing Manager and Digital Strategist, founder of Civico8ADV, a communication and digital marketing agency based in Livorno. He works on brand strategy, social media management, META ADS campaigns, positioning and storytelling for companies, professionals and destinations. He collaborates steadily with PR Comunicare il Vino on the digital strategy of some of the most renowned Italian wineries. He studied piano at the Pietro Mascagni Music Institute in Livorno.",
    },
  },
  {
    name: "Lucia Ilaria Ginocchi",
    role: { it: "Consigliere", en: "Board member" },
    image:
      "https://static.wixstatic.com/media/0de1ea_4207d3eb24bb459f8e9f99ea512544a0~mv2_d_1200_1208_s_2.jpg/v1/fill/w_500,h_620,al_c,q_85,enc_auto/lucia.jpg",
    bio: { it: "", en: "" },
  },
  {
    name: "Francesca Andreis",
    role: { it: "Consigliere", en: "Board member" },
    image:
      "https://static.wixstatic.com/media/0de1ea_3625c098befb473d942d9d4bc3a23524~mv2.jpg/v1/fill/w_500,h_620,al_c,q_85,enc_auto/francesca.jpg",
    bio: {
      it: "Ingegnere chimico, Collaboratore Tecnico Professionale esperto presso ARPAT.",
      en: "Chemical engineer and senior technical professional at ARPAT (Tuscany's environmental protection agency).",
    },
  },
  {
    name: "Maria Pia Bernardoni",
    role: { it: "Consigliere", en: "Board member" },
    image:
      "https://static.wixstatic.com/media/0de1ea_9807b76fdf02487298821035b0856b57~mv2_d_1219_1229_s_2.jpg/v1/fill/w_500,h_620,al_c,q_85,enc_auto/maria.jpg",
    bio: { it: "", en: "" },
  },
  {
    name: "Paola Ronzon",
    role: { it: "Segretario", en: "Secretary" },
    image:
      "https://static.wixstatic.com/media/0de1ea_f79a111ba341436397df319f418d9861~mv2.jpg/v1/fill/w_500,h_620,al_c,q_85,enc_auto/paola.jpg",
    bio: { it: "", en: "" },
  },
];

// Current board of directors (consiglio direttivo)
export const board = [
  {
    name: "Eva Kosa",
    role: { it: "Presidente", en: "President" },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/1iv6yh87_1740781636076.jpeg",
    bio: {
      it: "Docente di danza classica e contemporanea, attualmente insegna danza classica presso la scuola Officina delle Arti (Pieve a Nievole, PT). Direttrice artistica e organizzativa del progetto Interdanza (Livorno) e artistic agent del M° Luca D'Annunzio. Diplomata al Liceo di Coreografia e Arte Drammatica \"O. Stroia\" e laureata in Pedagogia Coreografica all'Accademia di Musica \"Gh. Dima\" di Cluj-Napoca (Romania); Master in Arts and Culture Management alla Rome Business School. Già ballerina del Teatro dell'Opera di Brasov, si è perfezionata nella danza contemporanea (metodo Cunningham) con Dino Verga presso Aterballetto.",
      en: "Teacher of classical and contemporary dance, currently teaching classical dance at the Officina delle Arti school (Pieve a Nievole, PT). Artistic and organisational director of the Interdanza project (Livorno) and artistic agent of Maestro Luca D'Annunzio. She graduated from the \"O. Stroia\" Choreography and Drama Lyceum and holds a degree in Choreographic Pedagogy from the \"Gh. Dima\" Music Academy in Cluj-Napoca (Romania), plus a Master in Arts and Culture Management from Rome Business School. A former dancer at the Brasov Opera Theatre, she specialised in contemporary dance (Cunningham method) with Dino Verga at Aterballetto.",
    },
  },
  {
    name: "Marco Maltinti",
    role: { it: "Vicepresidente", en: "Vice President" },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/5xuvdykj_1680279805574.jpeg",
    bio: {
      it: "Web Marketing Manager e Digital Strategist, fondatore di Civico8ADV, agenzia di comunicazione e marketing digitale con sede a Livorno. Si occupa di brand strategy, social media management, campagne META ADS, posizionamento e storytelling per aziende, professionisti e destinazioni. Collabora stabilmente con PR Comunicare il Vino, curando la strategia digitale di alcune tra le più riconosciute cantine italiane. Ha studiato pianoforte all'Istituto Musicale Pietro Mascagni di Livorno.",
      en: "Web Marketing Manager and Digital Strategist, founder of Civico8ADV, a communication and digital marketing agency based in Livorno. He works on brand strategy, social media management, META ADS campaigns, positioning and storytelling for companies, professionals and destinations. He collaborates steadily with PR Comunicare il Vino on the digital strategy of some of the most renowned Italian wineries. He studied piano at the Pietro Mascagni Music Institute in Livorno.",
    },
  },
  {
    name: "Francesca Andreis",
    role: { it: "Segretario", en: "Secretary" },
    image:
      "https://static.wixstatic.com/media/0de1ea_3625c098befb473d942d9d4bc3a23524~mv2.jpg/v1/fill/w_500,h_620,al_c,q_85,enc_auto/francesca.jpg",
    bio: {
      it: "Ingegnere chimico, Collaboratore Tecnico Professionale esperto presso ARPAT. Si occupa dell'istruttoria e della vigilanza sugli stabilimenti a rischio di incidente rilevante (normativa Seveso), della redazione dei piani di emergenza esterna, delle Autorizzazioni Integrate Ambientali (AIA/IPPC) e della gestione della rete di monitoraggio della qualità dell'aria. Team leader di gruppi di lavoro del SNPA.",
      en: "Chemical engineer and senior technical professional at ARPAT (Tuscany's environmental protection agency). She works on the technical assessment and inspection of major-accident hazard establishments (Seveso Directive), external emergency planning, integrated environmental permits (IPPC) and air quality monitoring. Team leader of SNPA working groups.",
    },
  },
];

export const interdanzaProgram = [
  {
    it: "Stages di danza (1-2 maggio) — classica, contemporanea, passo a due, PBT, storia della danza, variazioni e punte con docenti internazionali.",
    en: "Dance stages (1-2 May) — classical, contemporary, pas de deux, PBT, dance history, variations and pointe work with international teachers.",
  },
  {
    it: "Workshop coreografici — repertorio classico (Don Quixote di L. Minkus, \"Il Sogno\") e danza contemporanea, con incontri mensili fino a maggio.",
    en: "Choreographic workshops — classical repertoire (Don Quixote by L. Minkus, \"The Dream\") and contemporary dance, with monthly sessions until May.",
  },
  {
    it: "Audizione Messapica (2 maggio) — audizione ufficiale per l'International Ballet Company Messapica.",
    en: "Messapica audition (2 May) — official audition for the International Ballet Company Messapica.",
  },
  {
    it: "Borse di studio e opportunità di lavoro in Italia e all'estero.",
    en: "Scholarships and job opportunities in Italy and abroad.",
  },
  {
    it: "Gala finale \"Sulle ali della danza\" (3 maggio) al Teatro Goldoni, con ospiti internazionali e compagnie di danza.",
    en: "Final Gala \"Sulle ali della danza\" (3 May) at the Teatro Goldoni, with international guests and dance companies.",
  },
];

export const interdanzaEditions = [
  { year: "2013", title: { it: "Rapsodia rumena", en: "Romanian Rhapsody" }, author: "G. Enescu" },
  { year: "2014", title: { it: "Don Quixote", en: "Don Quixote" }, author: "L. Minkus" },
  { year: "2015", title: { it: "La bella addormentata", en: "The Sleeping Beauty" }, author: "P. I. Čajkovskij" },
  { year: "2016", title: { it: "Coppelia", en: "Coppélia" }, author: "L. Delibes" },
  { year: "2017", title: { it: "Lo schiaccianoci", en: "The Nutcracker" }, author: "P. I. Čajkovskij" },
  { year: "2018", title: { it: "Il lago dei cigni", en: "Swan Lake" }, author: "P. I. Čajkovskij" },
  { year: "2019", title: { it: "La Bayadère", en: "La Bayadère" }, author: "L. Minkus" },
  { year: "2020", title: { it: "Le due Giselle", en: "The two Giselles" }, author: "A. Adam" },
  { year: "2021", title: { it: "Interdanza online", en: "Interdanza online" }, author: "" },
  { year: "2022", title: { it: "Earth first", en: "Earth first" }, author: "" },
  { year: "2023", title: { it: "Sulle ali della danza", en: "Sulle ali della danza" }, author: "Luciana Savignano" },
  { year: "2024", title: { it: "Sulle ali della Danza", en: "Sulle ali della Danza" }, author: "Toon Lobach" },
  { year: "2025", title: { it: "Sulle ali della danza", en: "Sulle ali della danza" }, author: "Toon Lobach" },
  { year: "2026", title: { it: "Don Quixote — Il Sogno", en: "Don Quixote — The Dream" }, author: "L. Minkus" },
];

export const arteNaturaEvents = [
  {
    title: { it: "Noi siamo bosco", en: "Noi siamo bosco" },
    artist: 'Gian Luca Palazzolo "Libicocco"',
    date: {
      it: "Venerdì 28 aprile 2023 · 18.30–20",
      en: "Friday 28 April 2023 · 6:30–8 pm",
    },
    place: {
      it: "Mercato in Arte — Mercato delle Vettovaglie, via Buontalenti, Livorno",
      en: "Mercato in Arte — Mercato delle Vettovaglie, via Buontalenti, Livorno",
    },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/4yj0uqs8_481292977_666256726068005_2569377872408280648_n.jpg",
    text: {
      it: "Esseri umani da cui nascono e si formano piante, fiori, felci, funghi, piccoli boschi di alberi; coreografie di ballerine i cui movimenti — accompagnati dalla chitarra classica — rimandano a quelli delle creature del bosco, per ricordarci che non abbiamo mai reciso il legame con una natura di cui facciamo parte. Le opere sono rimaste esposte fino al 12 maggio.",
      en: "Human beings from whom plants, flowers, ferns, mushrooms and small woods take shape; choreographies whose movements — accompanied by the classical guitar — recall those of the creatures of the woods, reminding us that we have never truly severed our bond with a nature we have always belonged to. The works remained on show until 12 May.",
    },
    collab: {
      it: "Mercato in Arte, Extra Factory, Arsnova Scuola di Musica (chitarrista Giacomo Manfredini), Scuola di danza Dea, Charta Mare.",
      en: "Mercato in Arte, Extra Factory, Arsnova Music School (guitarist Giacomo Manfredini), Dea Dance School, Charta Mare.",
    },
  },
  {
    title: { it: "Sonora vibra plant", en: "Sonora vibra plant" },
    artist: "Martina Tamberi & Aurora Bresci",
    date: {
      it: "Sabato 6 maggio 2023 · 16–18",
      en: "Saturday 6 May 2023 · 4–6 pm",
    },
    place: {
      it: "Parco di Villa Maurogordato, via di Monterotondo 74, Livorno",
      en: "Villa Maurogordato park, via di Monterotondo 74, Livorno",
    },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/usgkvtro_481811824_668139469213064_4268806665375128455_n.jpg",
    text: {
      it: "Radici, foglie e cortecce: le vibrazioni della linfa diventano musica. Un allestimento itinerante creato dai suoni delle piante (prodotti dallo speciale strumento di Martina Tamberi), le ballerine della Scuola di danza Dea e la musica di Aurora Bresci, con l'esposizione di alcune opere de \"La carne delle piante\" e letture a tema.",
      en: "Roots, leaves and bark: the vibrations of the sap become music. A travelling installation created from the sounds of plants (produced by Martina Tamberi's special instrument), the dancers of the Dea Dance School and the music of Aurora Bresci, with a selection of works from \"La carne delle piante\" and themed readings.",
    },
    collab: {
      it: "Associazione Reset Livorno, Scuola di danza Dea.",
      en: "Reset Livorno Association, Dea Dance School.",
    },
  },
  {
    title: { it: "La carne delle piante", en: "La carne delle piante" },
    artist: "Aurora Bresci",
    date: {
      it: "Domenica 28 maggio e 4 giugno 2023 · dalle 19",
      en: "Sunday 28 May and 4 June 2023 · from 7 pm",
    },
    place: {
      it: "Thisintegra, via Mons. Filippo Ganucci 3 — quartiere La Venezia, Livorno",
      en: "Thisintegra, via Mons. Filippo Ganucci 3 — La Venezia district, Livorno",
    },
    image:
      "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/p82woah7_481679183_668740579152953_3725233373551816665_n.jpg",
    text: {
      it: "Nello spazio di Thisintegra varie forme artistiche dedicate alla natura: il percorso dell'installazione \"La carne delle piante\" — dipinti, stampe e installazioni che marcano il rapporto tra natura ed essere umano — la proiezione del video di \"Sonora Vibra Plant\" e momenti di danza, musica e teatro. Le opere sono rimaste esposte fino all'11 giugno.",
      en: "At the Thisintegra space, several art forms dedicated to nature: the trail of the installation \"La carne delle piante\" — paintings, prints and installations marking the relationship between nature and humankind — the screening of the \"Sonora Vibra Plant\" video, and moments of dance, music and theatre. The works remained on show until 11 June.",
    },
    collab: {
      it: "Thisintegra, Scuola di danza Dea, Arsnova Scuola di musica, I romanzi di Vanessa Turinelli (attore Santo Pagano).",
      en: "Thisintegra, Dea Dance School, Arsnova Music School, I romanzi di Vanessa Turinelli (actor Santo Pagano).",
    },
  },
];

// Arte & Natura — 2ª edizione (2024): SYMBIOSI "Il mare"
export const arteNaturaSymbiosi = {
  edition: { it: "2ª Edizione · 2024", en: "2nd Edition · 2024" },
  title: "Symbiosi",
  theme: { it: "Il mare", en: "The sea" },
  image:
    "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/35pl6f16_484982536_680468811313463_499751557762737408_n.jpg",
  intro: {
    it: "\"Symbiosi\" celebra l'armoniosa connessione tra arte e natura, unendo la magia della danza e dell'arte con la potenza evocativa della fotografia. Il focus centrale è il mare, elemento vitale per l'equilibrio del nostro pianeta: l'Acquario di Livorno diventa un punto focale, trasformandosi in un'opera d'arte vivente.",
    en: "\"Symbiosi\" celebrates the harmonious connection between art and nature, blending the magic of dance and art with the evocative power of photography. Its central focus is the sea, a vital element for our planet's balance: the Livorno Aquarium becomes a focal point, turning into a living work of art.",
  },
  body: {
    it: "Il titolo sottolinea l'interconnessione tra arte e natura, proprio come gli organismi viventi dipendono l'uno dall'altro. Le ballerine diventano modelle di scatti artistici in pose plastiche che evocano ambienti e creature sottomarine, con il corpo usato come tela vivente. Un invito a riflettere sul rapporto delicato tra l'uomo e l'ambiente marino.",
    en: "The title highlights the interconnection between art and nature, just as living organisms depend on one another. The dancers become models for artistic shots in sculptural poses evoking underwater environments and creatures, using the body as a living canvas — an invitation to reflect on the delicate relationship between humankind and the marine environment.",
  },
  sustainability: {
    it: "Costumi sostenibili: gli abiti dello shooting sono realizzati per l'85% con materiali di scarto, riadattati e rielaborati per dare nuova vita in modo creativo ai rifiuti che inquinano il mare, trasformandoli nel veicolo di un messaggio di tutela dell'ecosistema marino.",
    en: "Sustainable costumes: 85% of the shooting outfits are made from waste materials, reworked to creatively give new life to the waste polluting the sea, turning it into a vehicle for a message of protection for the marine ecosystem.",
  },
  team: [
    { role: { it: "Ideazione e movimento scenico", en: "Concept & stage movement" }, name: "Eva Kosa" },
    { role: { it: "Costumi", en: "Costumes" }, name: "Aurora Bresci" },
    { role: { it: "Trucco e body art", en: "Make-up & body art" }, name: "Martina Tamberi" },
    { role: { it: "Fotografo", en: "Photographer" }, name: "Paolo Bonciani" },
  ],
  activities: [
    {
      it: "Shooting fotografico — le ballerine come modelle di scatti artistici che evocano creature e ambienti sottomarini.",
      en: "Photo shoot — dancers as models for artistic shots evoking underwater creatures and environments.",
    },
    {
      it: "Mostra fotografica all'Acquario di Livorno (dicembre 2024) con una selezione di circa 20 opere e materiale audiovisivo.",
      en: "Photo exhibition at the Livorno Aquarium (December 2024) with a selection of about 20 works and audiovisual material.",
    },
    {
      it: "Installazione coreografica durante l'inaugurazione, con l'esposizione di alcuni dei costumi creati.",
      en: "Choreographic installation during the opening, with a display of some of the created costumes.",
    },
    {
      it: "Book fotografico che documenta l'intero processo creativo e gli scatti del fotografo Paolo Bonciani.",
      en: "Photo book documenting the whole creative process and the shots by photographer Paolo Bonciani.",
    },
  ],
  collab: {
    it: "Scuola di danza Dea, Alessandra Donati — Associazione Compagnia del Cerchio, Cristina Giorgerini (fotografa).",
    en: "Dea Dance School, Alessandra Donati — Compagnia del Cerchio Association, Cristina Giorgerini (photographer).",
  },
  exhibitions: {
    it: "Le fotografie e i costumi del progetto sono stati esposti in varie location dal 2024 a oggi, tra cui Extrafactory (Livorno) e CVM Venio (Larciano).",
    en: "The photographs and costumes of the project have been exhibited in various locations from 2024 to today, including Extrafactory (Livorno) and CVM Venio (Larciano).",
  },
};


// Arte & Natura — 3ª edizione: FIORI "La vita che ci unisce"
export const arteNaturaFiori = {
  edition: { it: "Arte & Natura · 3ª Edizione · 2026–2027", en: "Art & Nature · 3rd Edition · 2026–2027" },
  partOf: {
    it: "«Fiori» è la terza edizione del progetto Arte & Natura di arts4all.",
    en: "«Fiori» is the third edition of the Arte & Natura project by arts4all.",
  },
  title: "Fiori",
  subtitle: { it: "La vita che ci unisce", en: "The life that unites us" },
  heroImage:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_arte-natura-hub/artifacts/9ceb6dcfaa3d7998_e27be1c3-2902-45b5-ab9c-14358520bb6e.jfif",
  gallery: [
    "https://customer-assets-rejwkqb3.emergentagent.net/job_arte-natura-hub/artifacts/54524cb019b69c26_WhatsApp%20Image%202026-10-17%20at%2019.15.35%20%281%29.jpeg",
  ],
  intro: {
    it: "Dopo il percorso dedicato al mare e alla sua straordinaria biodiversità, Arte & Natura – Symbiosi torna attorno a un elemento apparentemente semplice, ma fondamentale per la vita del nostro pianeta: il fiore. I fiori sono parte degli ecosistemi — nutrono insetti e animali, favoriscono la riproduzione delle piante, custodiscono la biodiversità — ma sono anche cultura: vivono nell'arte, nella musica, nella poesia, nei rituali e nella memoria collettiva, simbolo di nascita, trasformazione, amore e rinascita.",
    en: "After the journey dedicated to the sea and its extraordinary biodiversity, Arte & Natura – Symbiosi returns around an apparently simple yet vital element: the flower. Flowers are part of ecosystems — they feed insects and animals, help plants reproduce and safeguard biodiversity — but they are also culture, living in art, music, poetry, rituals and collective memory, a symbol of birth, transformation, love and rebirth.",
  },
  intro2: {
    it: "«Fiori – La vita che ci unisce» racconta la simbiosi tra il mondo vegetale, l'ambiente e l'essere umano: un progetto multidisciplinare in cui fotografia, danza, musica, corpo, natura e divulgazione si incontrano per parlare a pubblici diversi, dai bambini agli adulti.",
    en: "«Fiori – The life that unites us» tells the symbiosis between the plant world, the environment and humankind: a multidisciplinary project where photography, dance, music, the body, nature and outreach meet to speak to different audiences, from children to adults.",
  },
  disciplines: [
    {
      icon: "camera",
      title: { it: "La fotografia", en: "Photography" },
      text: {
        it: "Paolo Bonciani accompagna il progetto con una ricerca dedicata ai fiori: non solo bellezza estetica, ma dettagli, forme, colori, trasformazioni e rapporto con il corpo umano. Le immagini diventeranno una mostra e il primo dei due libri.",
        en: "Paolo Bonciani accompanies the project with research dedicated to flowers: not only their beauty, but details, shapes, colours, transformations and their relationship with the human body. The images will become an exhibition and the first of the two books.",
      },
    },
    {
      icon: "dance",
      title: { it: "Il corpo e la danza", en: "The body and dance" },
      text: {
        it: "Con la ricerca di Eva Kosa la danza traduce il mondo vegetale in movimento: radici, germinazione, crescita, impollinazione, vento e ciclicità diventano gesti e relazioni. Non imitare il fiore, ma comprenderne la vita attraverso il corpo. Coinvolte alcune scuole di danza del territorio.",
        en: "Through Eva Kosa's research, dance translates the plant world into movement: roots, germination, growth, pollination, wind and cyclicity become gestures and relationships — not to imitate the flower, but to understand its life through the body. Local dance schools are involved.",
      },
    },
    {
      icon: "body",
      title: { it: "Il corpo come natura", en: "The body as nature" },
      text: {
        it: "Aurora Bresci porta la sua ricerca su costume, corpo e trasformazione visiva: tessuti, materiali, forme e colori ispirati ai fiori fanno sì che il corpo diventi paesaggio. L'uomo diventa fiore, il fiore diventa corpo.",
        en: "Aurora Bresci brings her research on costume, body and visual transformation: fabrics, materials, shapes and colours inspired by flowers turn the body into a landscape. The human becomes flower, the flower becomes body.",
      },
    },
    {
      icon: "sound",
      title: { it: "Body art e suono delle piante", en: "Body art and the sound of plants" },
      text: {
        it: "La ricerca di Martina Tamberi unisce body art e suono. Grazie a uno strumento che percepisce e trasforma i segnali delle piante, porta nelle performance il suono del mondo vegetale; con la body art, invece, il corpo diventa tela viva su cui fioriscono forme e colori della natura. La musica nasce dall'incontro con la natura e il corpo ne diventa parte. Un ponte diretto con il progetto Symbiosi.",
        en: "Martina Tamberi's research combines body art and sound. Through an instrument that senses and transforms the signals of plants, she brings the sound of the plant world into the performances; with body art, the body becomes a living canvas where nature's shapes and colours bloom. The music is born from the encounter with nature and the body becomes part of it. A direct bridge to the Symbiosi project.",
      },
    },
    {
      icon: "science",
      title: { it: "Cenni scientifici e curiosità", en: "Scientific hints and curiosities" },
      text: {
        it: "Il progetto non nasce da uno studio scientifico, ma si ispira a punti di riferimento e cenni scientifici sul mondo dei fiori. In dialogo con il Museo di Storia Naturale del Mediterraneo, piccole curiosità accompagnano il percorso: come comunicano le piante, il legame tra fiori e impollinatori, i colori e i profumi, i fiori commestibili e velenosi, il significato dei fiori nelle diverse culture e il loro ruolo nella biodiversità.",
        en: "The project does not stem from a scientific study, but draws on scientific reference points and insights about the world of flowers. In dialogue with the Natural History Museum of the Mediterranean, small curiosities accompany the journey: how plants communicate, the bond between flowers and pollinators, colours and scents, edible and poisonous flowers, the meaning of flowers across cultures and their role in biodiversity.",
      },
    },
  ],
  contest: {
    title: { it: "Concorso fotografico «Racconta un fiore»", en: "Photo contest «Tell a flower»" },
    soon: { it: "Il modulo d'iscrizione sarà disponibile dal 15 novembre.", en: "The registration form will be available from 15 November." },
    rulesUrl: "/docs/regolamento-racconta-un-fiore.pdf",
    rulesLabel: { it: "Scarica il regolamento (PDF)", en: "Download the rules (PDF, Italian)" },
    text: {
      it: "Un concorso aperto a professionisti, appassionati, giovani e cittadini. Il tema è il fiore, a scelta libera tra: il fiore e il territorio, il fiore e l'uomo, il fiore e la vita, il fiore nascosto, il fiore come arte. Una giuria qualificata selezionerà le opere vincitrici, con premi di valore; gli scatti selezionati entreranno nella mostra e nella pubblicazione. In palio borse di studio e masterclass gratuite.",
      en: "A contest open to professionals, enthusiasts, young people and citizens. The theme is the flower, freely chosen among: the flower and the land, the flower and humankind, the flower and life, the hidden flower, the flower as art. A qualified jury will select the winning works, with valuable prizes; selected shots will enter the exhibition and the publication. Scholarships and free masterclasses up for grabs.",
    },
  },
  books: [
    {
      title: { it: "Libro 1 — Fiori", en: "Book 1 — Fiori" },
      text: {
        it: "Un libro fotografico e artistico: le fotografie di Paolo Bonciani, interventi artistici, danza, volti e corpi, fiori e territorio. Una memoria permanente del percorso creativo, con il suono reale della pianta ritratta.",
        en: "A photographic and artistic book: the photographs by Paolo Bonciani, artistic interventions, dance, faces and bodies, flowers and land. A permanent memory of the creative journey, with the real sound of the photographed plant.",
      },
    },
    {
      title: { it: "Libro 2 — Fiori e ballerine", en: "Book 2 — Fiori e ballerine" },
      text: {
        it: "Un progetto narrativo e poetico, anche per bambini e famiglie: il mondo dei fiori raccontato tra immagini, danza e parole, recuperando filastrocche e rime legate alla memoria familiare. Libro originale scritto in lingua rumena dalla professoressa di danza Luminița Toader e tradotto in italiano da Eva Kosa.",
        en: "A narrative, poetic project, also for children and families: the world of flowers told through images, dance and words, recovering nursery rhymes and verses tied to family memory. Original book written in Romanian by the dance teacher Luminița Toader and translated into Italian by Eva Kosa.",
      },
    },
  ],
  finale: {
    it: "Il momento conclusivo prevede una performance site-specific negli spazi del Museo, con artisti e scuole di danza: la fotografia racconta, la danza interpreta, la musica ascolta, la natura suggerisce, i cenni scientifici accompagnano. Non uno spettacolo, ma un percorso immersivo tra arte e natura.",
    en: "The finale is a site-specific performance in the Museum's spaces, with artists and dance schools: photography tells, dance interprets, music listens, nature suggests, scientific insights accompany. Not a show, but an immersive journey between art and nature.",
  },
  concept: {
    it: "Un fiore sembra fragile, eppure senza i fiori la vita come la conosciamo sarebbe profondamente diversa. Dopo aver ascoltato il mare, impariamo ad ascoltare la terra attraverso i fiori.",
    en: "A flower seems fragile, yet without flowers life as we know it would be profoundly different. After listening to the sea, we learn to listen to the earth through flowers.",
  },
  team: [
    { role: { it: "Ideazione e direzione artistica", en: "Concept & artistic direction" }, name: "Eva Kosa" },
    { role: { it: "Fotografo", en: "Photographer" }, name: "Paolo Bonciani" },
    { role: { it: "Body art e ricerca sonora", en: "Body art & sound research" }, name: "Martina Tamberi" },
    { role: { it: "Costumi", en: "Costumes" }, name: "Aurora Bresci" },
    { role: { it: "Comunicazione", en: "Communication" }, name: "Valeria Benini" },
  ],
  venue: {
    it: "Museo di Storia Naturale del Mediterraneo, Livorno",
    en: "Natural History Museum of the Mediterranean, Livorno",
  },
  collab: {
    it: "Scuola di danza Dea e altre scuole di danza del territorio, Biricotti (negozio di fiori), Cristina Giorgerini (fotografa), Luminița Toader — Liceul de Coregrafie și Artă Dramatică «O. Stroia», Cluj (Romania).",
    en: "Dea dance school and other local dance schools, Biricotti (flower shop), Cristina Giorgerini (photographer), Luminița Toader — Liceul de Coregrafie și Artă Dramatică «O. Stroia», Cluj (Romania).",
  },
};


export const archiveEvents = [
  {
    year: "2010",
    title: { it: "Schumann e il Romanticismo", en: "Schumann and Romanticism" },
    place: { it: "Circolo Musicale \"Galliano Masini\", Livorno", en: "Circolo Musicale \"Galliano Masini\", Livorno" },
    image:
      "https://static.wixstatic.com/media/0de1ea_dd493d5ddbd642b58df033af839da39e~mv2_d_3449_2299_s_2.jpg/v1/fill/w_640,h_420,al_c,q_85,enc_auto/schumann.jpg",
    text: {
      it: "Serata di musica classica con un repertorio di Schumann, Dvořák, Ravel, Verdi e Gershwin, eseguito dalla pianista Christine Chiriac, dalla soprano Elena Dinca e dal duo pianistico Panicucci-Camarlinghi (Ass. Nuovi Suoni).",
      en: "A classical music evening with a repertoire of Schumann, Dvořák, Ravel, Verdi and Gershwin, performed by pianist Christine Chiriac, soprano Elena Dinca and the piano duo Panicucci-Camarlinghi (Nuovi Suoni Ass.).",
    },
  },
  {
    year: "2010",
    title: { it: "Da Schumann ad Edith Piaf — Eroismo ed inquietudine", en: "From Schumann to Edith Piaf — Heroism and unrest" },
    place: { it: "Teatro dei Salesiani, Livorno", en: "Teatro dei Salesiani, Livorno" },
    image:
      "https://static.wixstatic.com/media/0de1ea_416c23bc227c4c81a60cdd5f64681d5c~mv2_d_4252_3029_s_4_2.jpg/v1/fill/w_640,h_420,al_c,q_85,enc_auto/piaf.jpg",
    text: {
      it: "Spettacolo di musica e danza con musiche di Schumann e coreografie di Mitzi e Cecilia Testi su brani di Craig Richey, Gotan Project ed Edith Piaf, regia di Eva Kosa.",
      en: "Music and dance show with music by Schumann and choreographies by Mitzi and Cecilia Testi on pieces by Craig Richey, Gotan Project and Edith Piaf, directed by Eva Kosa.",
    },
  },
  {
    year: "2009",
    title: { it: "La voce della musica", en: "The voice of music" },
    place: { it: "Circolo Musicale \"Galliano Masini\", Livorno", en: "Circolo Musicale \"Galliano Masini\", Livorno" },
    image:
      "https://static.wixstatic.com/media/0de1ea_c5ddb640cead4163874e99c78ce5b921~mv2_d_4350_3029_s_4_2.jpg/v1/fill/w_640,h_420,al_c,q_85,enc_auto/voce.jpg",
    text: {
      it: "Ospite internazionale il violinista rumeno Bogdan Alexandru Costache, accompagnato al pianoforte da Debora Camarlinghi. In programma brani del repertorio rumeno e un duo pianistico dell'Associazione Nuovi Suoni.",
      en: "International guest the Romanian violinist Bogdan Alexandru Costache, accompanied on piano by Debora Camarlinghi. The programme featured pieces from the Romanian repertoire and a piano duo from the Nuovi Suoni Association.",
    },
  },
];

export const galleryImages = [
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/k00wr7x5_BON_6763%20copia.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/6cjvuoha_596820277_1421276956672232_4477619180498129117_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/zhblm882_481646716_668758462484498_5391056703467919682_n.webp",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/4w0dbivu__MGM0488.png",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/1b7dxyvk_597850395_1421276953338899_7411588003952873013_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/grkxikbt_485000924_680468794646798_2694106701178123974_n.webp",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/05jw6syx_481965642_668758469151164_6301292166485589911_n.webp",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/35pl6f16_484982536_680468811313463_499751557762737408_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/awpsxhd5_485344703_679807758046235_6758646946586795103_n.webp",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/0ibug388_690682906_1551620750304518_1940777539952043024_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/wegujxkd_11160560_1618996871670776_2981259788669817881_n.png",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/chsre3nw_482223060_668758775817800_7054106516850440029_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/qiay15qo_IMG_4626.png",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/ropxl7py_484799593_679807724712905_2477841156709660077_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/0lpymz8d_482049595_668741582486186_4603822169808754167_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/4yj0uqs8_481292977_666256726068005_2569377872408280648_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/c2tr2s55_IMG_4569.png",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/mhx3jpyn_493808135_3967244253547193_5096490682008154557_n.jpg",
  "https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/usgkvtro_481811824_668139469213064_4268806665375128455_n.jpg",
  "https://static.wixstatic.com/media/0de1ea_c5ddb640cead4163874e99c78ce5b921~mv2_d_4350_3029_s_4_2.jpg/v1/fill/w_600,h_450,al_c,q_85,enc_auto/g1.jpg",
  "https://static.wixstatic.com/media/0de1ea_dd493d5ddbd642b58df033af839da39e~mv2_d_3449_2299_s_2.jpg/v1/fill/w_600,h_450,al_c,q_85,enc_auto/g2.jpg",
  "https://static.wixstatic.com/media/0de1ea_416c23bc227c4c81a60cdd5f64681d5c~mv2_d_4252_3029_s_4_2.jpg/v1/fill/w_600,h_450,al_c,q_85,enc_auto/g3.jpg",
];

export const collaborations = [
  {
    name: "Scuola di Canto e Arte Melodrammatica",
    subtitle: "M° Luca D'Annunzio",
    url: "https://www.lucadannunzio.com",
    desc: {
      it: "Centro di alto perfezionamento diretto dal Maestro Luca D'Annunzio, dedicato alla formazione di cantanti lirici nel solco della tradizione vocale italiana ottocentesca.",
      en: "A centre of excellence directed by Maestro Luca D'Annunzio, dedicated to training opera singers in the tradition of nineteenth-century Italian vocal art.",
    },
  },
  {
    name: "International Ballet Company Messapica",
    subtitle: "Mesagne (BR)",
    url: "https://www.internationalballetcompanymessapica.it",
    desc: {
      it: "Compagnia di danza internazionale con sede a Mesagne, in Puglia, che offre concrete opportunità ai giovani talenti in Italia e all'estero. Partner delle audizioni Interdanza.",
      en: "An international dance company based in Mesagne, Puglia, offering real opportunities to young talents in Italy and abroad. Partner of the Interdanza auditions.",
    },
  },
];

export const contactInfo = {
  email: "info.arts4all@yahoo.com",
  pec: "info.arts4all@pec.it",
  phone: "+39 392 7273083",
  vat: "01615210497",
  iban: "IT08T0306913906100000001517",
  swift: "BCITITMM",
  bank: "BANCA INTESA SANPAOLO",
  instagram: "https://www.instagram.com/arts4all.italy/?hl=it",
  facebook: "https://www.facebook.com/arts4all.italy",
  interdanza: "https://www.interdanza.it",
};
